import './App.css'
import React, { useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './bootstrap.min.css'
import './common.scss'
import Layout from './components/Layout'
import { PATH } from './constants/router'
import { AppParamsContextProvider } from './context/AppParamsContext'
import { AppUserContextProvider } from './context/AppUserContext'
import { ROUTERS } from './router'
import "./translations/i18next"
function App() {
  // Kiểm tra xem có APIKey trong URL không
  const urlParams = new URLSearchParams(window.location.search);
  const apiKey = urlParams.get('apiKey') || urlParams.get('apikey') || localStorage.getItem('apiKey') || localStorage.getItem('apikey') || process.env.REACT_APP_APIKEY || undefined;
  if(apiKey) {
    localStorage.setItem('apiKey', apiKey)
  }

  const themeApp = process.env.REACT_APP_THEME_NAME

  useLayoutEffect(() => {
    document.body.setAttribute('data-theme', themeApp)

    const loadingScreen = document.querySelector('.splash-screen-loading')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  }, [themeApp])

  return (
    <AppParamsContextProvider>
      <AppUserContextProvider>
        <Router>
          <Switch>
            {Object.keys(ROUTERS).map((key) => {
              return (
                <Route
                  key={ROUTERS[key].path || key}
                  exact
                  path={ROUTERS[key].path}
                  component={(props) => (
                    <React.Suspense fallback={null}>
                      <Layout {...props} Component={ROUTERS[key].component} hideMobileMenu={ROUTERS[key].hideMobileMenu} />
                    </React.Suspense>
                  )}
                />
              )
            })}
            <Redirect to={PATH.HOME} />
          </Switch>
        </Router>
      </AppUserContextProvider>
    </AppParamsContextProvider>
  )
}

export default App
